import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/map-demo')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
  component: () => null,
});
